export default __webpack_public_path__ + "static/media/trial-200.168fb8cc.png";